import './html-embed-component';

import {
  createEmbedBlockSchema,
  defineEmbedModel,
  type EmbedHtmlBlockProps,
} from '@blocksuite/affine-model';
import { EmbedHtmlBlockSpec } from '@blocksuite/blocks';
import { BlockModel } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { PiqueEmbedHtmlBlockService } from './html-embed-service.js';

// Default dimensions for the iframe
export const DEFAULT_IFRAME_WIDTH = '187.5px';
export const DEFAULT_IFRAME_HEIGHT = '82.5px';

// Default block imports from blocksuite
export type EmbedCardStyle =
  | 'horizontal'
  | 'horizontalThin'
  | 'list'
  | 'vertical'
  | 'cube'
  | 'cubeThick'
  | 'video'
  | 'figma'
  | 'html'
  | 'syncedDoc';

export const EmbedHtmlStyles: EmbedCardStyle[] = ['html'] as const;

export interface PiqueEmbedHtmlDesign {
  embedHtmlStyle?: {
    margin?: string;
    padding?: string;
    border?: string;
    overflow?: string;
    height?: string;
  };
}

const defaultEmbedHtmlProps: EmbedHtmlBlockProps = {
  style: EmbedHtmlStyles[0] ?? 'html',
  html: '',
  caption: null,
  design: '',
};

// Define a new type that extends EmbedHtmlBlockProps with our new field
export type PiqueEmbedHtmlBlockProps = EmbedHtmlBlockProps & {
  url: string;
  htmlSlides?: string[]; // New optional property for carousel support
};

// Create a new model that extends BlockModel with our updated Props
export class PiqueEmbedHtmlModel extends defineEmbedModel<PiqueEmbedHtmlBlockProps>(
  BlockModel
) {
  // Any additional methods or overrides can be added here if needed
}

const defaultPiqueEmbedHtmlProps: PiqueEmbedHtmlBlockProps = {
  ...defaultEmbedHtmlProps,
  url: '',
  htmlSlides: undefined, // Default to undefined for backward compatibility
};

export const PiqueEmbedHtmlBlockSchema = createEmbedBlockSchema({
  name: 'pique-html',
  version: 1,
  toModel: () => new PiqueEmbedHtmlModel(),
  props: (): PiqueEmbedHtmlBlockProps => defaultPiqueEmbedHtmlProps,
});

// Define the block spec
export const PiqueHtmlEmbedBlockSpec = {
  ...EmbedHtmlBlockSpec,
  schema: PiqueEmbedHtmlBlockSchema,
  service: PiqueEmbedHtmlBlockService,
  view: {
    component: literal`pique-html-embed-block`,
  },
};
